import i18n from "@microdoing/shared/i18n";
import { getUserCampaignHasPeerToPeer } from "@microdoing/shared/services/userCampaign/selectors";
import { Box, MainText, PressableOpacity } from "app/components/common";
import DropDownText from "app/components/common/DropDownText";
import { StarImage } from "app/scenes/FeedbackScreen/ReflexiveAnalysis/ActionRatingScreen/RatingStar";
import normalize from "app/utils/normalize";
import React from "react";
import FastImage from "react-native-fast-image";
import { useSelector } from "react-redux";
import MultipleAvatars from "../../TeamScreen/MultipleAvatars";
import getRandomTotalDoneFromString from "@microdoing/shared/utils/getRandomTotalDoneFromString";
import getRandomRatingFromString from "@microdoing/shared/utils/getRandomRatingFromString";
import getRandomAvatarsFromNumber from "@microdoing/shared/utils/getRandomAvatarsFromNumber";
import { pluralizeI18n } from "app/utils/plurialize";

interface Props {
  rating: number;
  numberOfComments: number;
  onPressSocialSheet: (numberOfComments: number) => void;
  users: any[];
  totalDone?: number;
  sheetOpen?: boolean;
  contentTitle: string;
}

const SocialSheetInfos = ({
  rating,
  numberOfComments,
  onPressSocialSheet,
  users,
  sheetOpen = false,
  totalDone = 0,
  contentTitle = "",
}: Props) => {
  const hasPeerToPeer = useSelector(getUserCampaignHasPeerToPeer);

  const goodRating = rating || getRandomRatingFromString(contentTitle);
  const goodTotalDone =
    totalDone > 20 ? totalDone : getRandomTotalDoneFromString(contentTitle);

  const goodAvatars =
    hasPeerToPeer && numberOfComments !== 0
      ? users
      : getRandomAvatarsFromNumber({
          baseNumber: goodTotalDone,
        });

  const handlePress = () => {
    if (!hasPeerToPeer) return null;
    if (numberOfComments === 0) return null;
    onPressSocialSheet(numberOfComments);
  };

  return (
    <PressableOpacity
      style={{
        width: "100%",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row",
      }}
      onPress={handlePress}
    >
      <Box alignItems="center" flexDirection="row" justifyContent="center">
        <FastImage
          source={StarImage}
          style={{
            width: normalize(16),
            height: normalize(16),
          }}
        />
        <MainText marginLeft="xs" variant="l3-medium" color="neutral.900">
          {goodRating?.toFixed(1)}
        </MainText>
      </Box>
      {hasPeerToPeer && numberOfComments !== 0 ? (
        <Box
          flex={1}
          flexDirection="row"
          marginLeft="sm"
          justifyContent="center"
          alignItems="center"
        >
          <Box flex={1} alignItems="center" justifyContent="center">
            <MultipleAvatars
              size={normalize(20)}
              avatars={users}
              maxNumberOfAvatars={3}
            />
          </Box>
          <Box marginLeft="sm" justifyContent="center" alignItems="center">
            <DropDownText
              text={
                numberOfComments +
                " " +
                pluralizeI18n("comment", numberOfComments)
              }
              isOpen={sheetOpen}
              onPress={handlePress}
            />
          </Box>
        </Box>
      ) : (
        <Box
          flex={1}
          flexDirection="row"
          marginLeft="sm"
          alignItems="center"
          justifyContent="center"
        >
          <Box flex={1} alignItems="center" justifyContent="center">
            <MultipleAvatars
              size={normalize(20)}
              avatars={goodAvatars}
              maxNumberOfAvatars={4}
            />
          </Box>
          <Box
            flexDirection="row"
            marginLeft="sm"
            alignItems="center"
            justifyContent="center"
          >
            <MainText variant="l3-medium" marginRight="xxs">
              {goodTotalDone}
            </MainText>
            <MainText variant="l3-medium">{i18n.t("participants")}</MainText>
          </Box>
        </Box>
      )}
    </PressableOpacity>
  );
};

export default SocialSheetInfos;
